export const firebaseConfig = {
  apiKey: "AIzaSyARkhNIad44CxKS50T5i_7CLcnmrXeI79w",
  authDomain: "crew-dev-cad96.firebaseapp.com",
  projectId: "crew-dev-cad96",
  storageBucket: "crew-dev-cad96.appspot.com",
  messagingSenderId: "946989205783",
  appId: "1:946989205783:web:198852ec3afb88a19fcf52"
};